import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'



export const fetchCreditReport = createAsyncThunk(
  'creditReports/fetchCreditReport',
  async ({ jwtBearer, rpm }, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}pipeline/summary/credit/`
      if (rpm) {
        url += `?rpm=${rpm}`
      }
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      })

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload()
        }
        return rejectWithValue(await response.json())
      }

      return await response.json()
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchCreditReportV2 = createAsyncThunk(
  'creditReports/fetchCreditReportV2',
  async ({ jwtBearer, rpm }, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}pipeline/summary/credit/v2/`
      if (rpm) {
        url += `?rpm=${rpm}`
      }
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      })

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload()
        }
        return rejectWithValue(await response.json())
      }

      return await response.json()
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)



const creditReportSlice = createSlice({
  name: 'creditReports',
  initialState: {
    isLoading: false,
    data: null,
    dataV2: null,
    isError: false,
    error: null
  },
  reducers: {
    resetCreditReportState: state => {
      state.isLoading = false
      state.isError = false
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      /* ---------- V1 ---------- */
      .addCase(fetchCreditReport.pending, state => {
        state.isLoading = true
        state.isError = false
        state.error = null
      })
      .addCase(fetchCreditReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
      })
      .addCase(fetchCreditReport.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.error = action.payload
      })

      /* ---------- V2 ---------- */
      .addCase(fetchCreditReportV2.pending, state => {
        state.isLoading = true
        state.isError = false
        state.error = null
      })
      .addCase(fetchCreditReportV2.fulfilled, (state, action) => {
        state.isLoading = false
        state.dataV2 = action.payload
      })
      .addCase(fetchCreditReportV2.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.error = action.payload
      })
  }
})

export const { resetCreditReportState } = creditReportSlice.actions
export default creditReportSlice.reducer
